// extracted by mini-css-extract-plugin
module.exports = {"inputGroup":"inputGroup__3GiKi","multiple":"multiple__3XtkV"};